import { useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Button,
  Grid,
  Divider,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import { IsMobile } from "utils/is-mobile";
import ClearButton from "components/_refactor/button/clear";
import componentStyles from "assets/theme/views";

const useStyles = makeStyles(componentStyles);

export default function FilterCard({
  children,
  handleSearch,
  searching,
  disabled,
  handleClearFilters,
  bottonInfo,
}) {
  const [isExpanded, setIsExpanded] = useState(true);

  const isMobile = IsMobile();
  const classes = useStyles();

  return (
    <Card classes={{ root: classes.cardRoot }}>
      <CardContent>
        <Grid
          container
          alignItems="center"
          direction="row"
          justify="space-between"
        >
          <Typography variant="h2">Filtros</Typography>
          {isExpanded ? (
            <ExpandLess
              style={{ width: "25px", height: "25px" }}
              onClick={() => setIsExpanded(!isExpanded)}
            />
          ) : (
            <ExpandMore
              style={{ width: "25px", height: "25px" }}
              onClick={() => setIsExpanded(!isExpanded)}
            />
          )}
        </Grid>
        {isExpanded && (
          <>
            <Grid item xs={12}>
              <Divider />
            </Grid>

            <Grid container spacing={2} style={{ padding: "1rem 0" }}>
              {children}
            </Grid>

            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={6}>
                <Button
                  style={
                    isMobile
                      ? {
                          width: "100%",
                          margin: "0.75rem 0",
                        }
                      : { width: "200px" }
                  }
                  color="default"
                  variant="contained"
                  onClick={handleSearch}
                  disabled={disabled}
                >
                  {searching ? "Pesquisando..." : "Pesquisar"}
                </Button>
              </Grid>
             {handleClearFilters && (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <ClearButton
                    disable={disabled}
                    fullWidth={true}
                    onClick={handleClearFilters}
                  />
                </Grid>
             )}
            </Grid>

            {bottonInfo}
          </>
        )}
      </CardContent>
    </Card>
  );
}
